import { render, staticRenderFns } from "./comment-badge.vue?vue&type=template&id=540172f9&"
import script from "./comment-badge.vue?vue&type=script&lang=js&"
export * from "./comment-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports